import { Col, Row, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Card } from "antd";
import CardImageItem from "../../Users/component/CardImage";

const DetailMateriel = ({ modal, setModal, toggle, selectedMateriel }) => {
  const { category, color, description,filename,name,nbMaterial,serialNumber,state,status,type,version,actualUserId } = selectedMateriel || {};

  // const { isLoading: isLoadingDrivers, isError: isErrorDrivers, error, data: driver } = useQuery(
  //   ["driver", actualUserId], () => getUserById(actualUserId),
  //   { enabled: !!actualUserId }
  // );

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "900px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Détail du matériel
      </ModalHeader>

      <ModalBody style={{ padding: "2rem 3rem", backgroundColor: "#f7f7f7" }}>
        <Card className="card-animate">
          <Row>
            <Col lg={6}  className="mt-4">
              <div style={{ width: '70%', margin: '0 auto', height: '100%' }}>
                <CardImageItem fileName={filename}/>
              </div>
            </Col>
            <Col lg={6}>
                <br/>
                <Card title="Information supplémentaire">
                  <div className="text-left mb-4">
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr><td style={{ fontWeight: "600" }}>Nom </td><td>{name || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Nombre </td><td>{nbMaterial || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Statut </td><td>{status || "-"}</td></tr>                        
                        {/* <tr><td style={{ fontWeight: "600" }}>Chauffeur</td><td>{driver?.name || "-"}</td></tr> */}
                      </tbody>
                    </table>
                    <strong>Description : </strong> {description || "-"}
                  </div>
                </Card>
            </Col>
          </Row>
        </Card>

      </ModalBody>
    </Modal>
  );
};

export default DetailMateriel;
